import { JWT_TOKEN, SYSTEM_ROLE } from 'src/config/constants';
import { Authorities } from 'src/models/authorizations.model';
import { LoginData } from 'src/models/login.model';

export const hasAnyCapability = (capabilitiesAuthorized: Authorities[] | null, hasAnyCapabilities: Authorities[] | undefined) => {
  if (!hasAnyCapabilities || hasAnyCapabilities?.length === 0) {
    return true;
  }
  return hasAnyCapabilities.some(cap => capabilitiesAuthorized && capabilitiesAuthorized.includes(cap));
};

export const loginData: LoginData = {
  email: '',
  password: '',
  rememberMe: true,
};

export const getJwtToken = () => {
  return localStorage.getItem(JWT_TOKEN) || sessionStorage.getItem(JWT_TOKEN);
};

export const isSystem = (authorityName: string) => {
  return authorityName === SYSTEM_ROLE;
};
